import vars from "../helpers";

let $btnOpen = null;
let $btnClose = null;
let $storiesDetail = null;

function openStoriesDetail() {
	vars.$html.addClass('is-lock-scroll');

	if ($storiesDetail) {
		$storiesDetail.classList.add('is-visible');

		setTimeout(() => {
			$storiesDetail.classList.add('is-active');
		}, 200);
	}
}

function closeStoriesDetail() {
	vars.$html.removeClass('is-lock-scroll');

	if ($storiesDetail) {
		$storiesDetail.classList.remove('is-active');

		setTimeout(() => {
			if ($storiesDetail) {
				$storiesDetail.classList.remove('is-visible');
			}
		}, 200);
	}
}

function init(container) {
	$btnOpen = container.querySelector('.js-open-stories-detail');
	$btnClose = container.querySelector('.js-close-stories-detail');
	$storiesDetail = container.querySelector('.js-stories-detail');

	$btnOpen.addEventListener('click', openStoriesDetail);
	$btnClose.addEventListener('click', closeStoriesDetail);
}

function destroy() {
	$btnOpen.removeEventListener('click', openStoriesDetail);
	$btnClose.removeEventListener('click', closeStoriesDetail);

	$btnOpen = null;
	$btnClose = null;
	if ($storiesDetail) {
		$storiesDetail = null;
	}
}

export default {
	init,
	destroy,
	closeStoriesDetail,
}
